import React from "react";
import { Container, Row, Col } from "react-bootstrap";
// import PlayVideo from "../Play/PlayVideo";

import CTABtnModule from "../../modules/cta_btn_module";
import ContentModule from "../../modules/content_module";
import ImageModule from "../../modules/image_module";
import PlayVideo from "../../modules/video_module/PlayVideo";

import "./TextImageBlock.scss";

const TextImageBlock = ({Module, GQLPage}) => {

    var imagename = "pages.video_section_image.video_image";

    let processedImages = JSON.stringify({});
    if (GQLPage?.imagetransforms?.video_section_image_Transforms) {
        processedImages = GQLPage?.imagetransforms?.video_section_image_Transforms;
    }

    return (
        <React.Fragment>
            <section className={`customer text_block`}>
                <Container>
                    <Row>
                        <Col>
                            <div className="customer-wrapper">
                                {Module?.media_block?.media_file?.url && 
                                    <div className="video-img img-zoom">
                                        {/* {<ImageModule ImageSrc={Module?.media_block?.media_file}  altText={Module?.text_block?.title}/> } */}
                                        
                                        <ImageModule ImageSrc={Module?.media_block?.media_file} altText={Module?.text_block?.title} imagetransforms={processedImages} renderer="srcSet" imagename={imagename} strapi_id={GQLPage?.id} />  
                                    
                                    </div>
                                }
                                <div className={`video-content ${Module?.media_block?.media_file?.url ? "" : "full_wdth"}`}>
                                    {Module?.text_block?.title && <h3>{Module?.text_block?.title}</h3>}
                                    
                                    {Module?.text_block?.description && <ContentModule Content={Module?.text_block?.description} /> }

                                    {Module?.Button_CTA && <CTABtnModule button_cta={Module.Button_CTA} /> }
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

        </React.Fragment>
    );
};
export default TextImageBlock;